// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { ChevronLeft, Upload, Link, X, Plus, Info, Check } from "lucide-react";
// import { toast } from "react-toastify";
// import api from "../../../common/apiClient";
// import SummaryApi from "../../../common/SummaryApi";

// const LMSCourseForm = () => {
//   const { id, portalName } = useParams();
//   const navigate = useNavigate();
//   const isEditMode = Boolean(id);

//   const [loading, setLoading] = useState(false);
//   const [contentType, setContentType] = useState("upload"); // 'upload' or 'link'
  
//   // State matching your Mongoose Schema
//   const [formData, setFormData] = useState({
//     courseTitle: "",
//     category: "",
//     subCategory: "",
//     level: "",
//     duration: "",
//     description: "",
//     courseTags: [],
//     enableDiscussion: false,
//     requireAssessment: false,
//     allowDownload: false,
//     courseExpiry: false,
//     validityAfterCompletion: "",
//     renewalFrequency: "Never",
//     minimumPassingScore: 70,
//     maxAttempts: 3,
//     status: "Draft",
//     uploadContent: [] 
//   });

//   const [files, setFiles] = useState({
//     thumbnail: null,
//     banner: null,
//     contents: [] // For multiple content files
//   });

//   const [linkInput, setLinkInput] = useState("");

//   // Load course data if in Edit Mode
//   useEffect(() => {
//     if (isEditMode) {
//       const fetchCourse = async () => {
//         try {
//           const response = await api({ ...SummaryApi.getLmsCourseById(id) });
//           if (response.data.success) {
//             setFormData(response.data.data);
//           }
//         } catch (error) {
//           toast.error("Failed to load course data");
//         }
//       };
//       fetchCourse();
//     }
//   }, [id, isEditMode]);

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value
//     }));
//   };

//   const handleFileChange = (e, field) => {
//     if (field === "contents") {
//         setFiles(prev => ({ ...prev, contents: [...prev.contents, ...e.target.files] }));
//     } else {
//         setFiles(prev => ({ ...prev, [field]: e.target.files[0] }));
//     }
//   };

//   const handleSubmit = async (statusOverride) => {
//     try {
//       setLoading(true);
//       const data = new FormData();
      
//       // Append basic fields
//       Object.keys(formData).forEach(key => {
//         if (["courseTags", "uploadContent", "additional"].includes(key)) {
//           data.append(key, JSON.stringify(formData[key]));
//         } else {
//           data.append(key, statusOverride && key === 'status' ? statusOverride : formData[key]);
//         }
//       });

//       // Append files
//       if (files.thumbnail) data.append("thumbnail", files.thumbnail);
//       if (files.banner) data.append("banner", files.banner);
//       files.contents.forEach(file => data.append("contents", file));

//       const apiConfig = isEditMode 
//         ? SummaryApi.updateLmsCourse(id) 
//         : SummaryApi.createLmsCourse;

//       const response = await api({
//         ...apiConfig,
//         data: data,
//         headers: { "Content-Type": "multipart/form-data" }
//       });

//       if (response.data.success) {
//         toast.success(isEditMode ? "Course Updated" : "Course Created");
//         navigate(`/${portalName}/lms/courses`);
//       }
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Operation failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="bg-gray-50 min-h-screen pb-20">
//       {/* Top Header */}
//       <div className="bg-white border-b sticky top-0 z-20 px-6 py-4 flex items-center justify-between">
//         <div className="flex items-center gap-4">
//           <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-full transition">
//             <ChevronLeft size={20} />
//           </button>
//           <div>
//             <h1 className="text-xl font-bold text-gray-900">{isEditMode ? "Edit Course" : "Create New Course"}</h1>
//             <p className="text-xs text-gray-500">Build engaging courses and assign learning to your teams</p>
//           </div>
//         </div>
//         <div className="flex items-center gap-3">
//           <button 
//             disabled={loading}
//             onClick={() => handleSubmit("Draft")}
//             className="px-4 py-2 text-sm font-semibold border rounded-lg hover:bg-gray-50"
//           >
//             Save as Draft
//           </button>
//           <button 
//             disabled={loading}
//             onClick={() => handleSubmit("Published")}
//             className="px-4 py-2 text-sm font-semibold bg-red-600 text-white rounded-lg hover:bg-red-700 flex items-center gap-2 shadow-sm"
//           >
//             {isEditMode ? "Update Course" : "Publish Course"} <Check size={16} />
//           </button>
//         </div>
//       </div>

//       <div className="mx-auto p-4 grid grid-cols-1 lg:grid-cols-12 gap-4">
//         {/* Left Column: Information */}
//         <div className="lg:col-span-8 space-y-4">
//           <section className="bg-white p-6 rounded-xl border shadow-sm">
//             <h2 className="text-lg font-bold mb-6 flex items-center gap-2">Basic Information</h2>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div className="md:col-span-1">
//                 <label className="block text-sm font-semibold text-gray-700 mb-1.5">Course Title *</label>
//                 <input 
//                   name="courseTitle"
//                   value={formData.courseTitle}
//                   onChange={handleInputChange}
//                   placeholder="Enter course title"
//                   className="w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-red-500 outline-none transition"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-1.5">Course Code (Auto)</label>
//                 <input disabled value="LMS-AUTO-GEN" className="w-full px-4 py-2.5 border rounded-lg bg-gray-50 text-gray-500" />
//               </div>
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-1.5">Category *</label>
//                 <select name="category" value={formData.category} onChange={handleInputChange} className="w-full px-4 py-2.5 border rounded-lg outline-none focus:ring-2 focus:ring-red-500">
//                   <option value="">Select Category</option>
//                   <option value="Safety">Safety</option>
//                   <option value="Compliance">Compliance</option>
//                 </select>
//               </div>
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-1.5">Duration *</label>
//                 <input name="duration" value={formData.duration} onChange={handleInputChange} placeholder="e.g. 2h 30m" className="w-full px-4 py-2.5 border rounded-lg outline-none focus:ring-2 focus:ring-red-500" />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-semibold text-gray-700 mb-1.5">Description</label>
//                 <textarea 
//                   name="description"
//                   value={formData.description}
//                   onChange={handleInputChange}
//                   rows={4} 
//                   maxLength={500}
//                   className="w-full px-4 py-2.5 border rounded-lg outline-none focus:ring-2 focus:ring-red-500 resize-none"
//                   placeholder="Enter a short description about this course"
//                 />
//               </div>
//             </div>

//             {/* Upload Area */}
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
//                <div className="border-2 border-dashed border-gray-200 rounded-xl p-6 text-center hover:border-red-500 transition-colors cursor-pointer relative">
//                   <input type="file" onChange={(e) => handleFileChange(e, "thumbnail")} className="absolute inset-0 opacity-0 cursor-pointer" />
//                   <Upload className="mx-auto mb-2 text-red-600" size={32} />
//                   <p className="text-sm font-bold">Course Thumbnail</p>
//                   <p className="text-[10px] text-gray-400">PNG, JPG (Max 2MB). Recommended: 1280x720px</p>
//                </div>
//                <div className="border-2 border-dashed border-gray-200 rounded-xl p-6 text-center hover:border-red-500 transition-colors cursor-pointer relative">
//                   <input type="file" onChange={(e) => handleFileChange(e, "banner")} className="absolute inset-0 opacity-0 cursor-pointer" />
//                   <Upload className="mx-auto mb-2 text-red-600" size={32} />
//                   <p className="text-sm font-bold">Course Banner</p>
//                   <p className="text-[10px] text-gray-400">PNG, JPG (Max 5MB). Recommended: 1920x600px</p>
//                </div>
//             </div>
//           </section>

//           {/* Settings Section */}
//           <section className="bg-white p-6 rounded-xl border shadow-sm">
//             <h2 className="text-lg font-bold mb-6">Settings</h2>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               {[
//                 { label: "Enable Discussion", key: "enableDiscussion", desc: "Allow learners to discuss with each other" },
//                 { label: "Require Assessment", key: "requireAssessment", desc: "Learner must pass assessment to complete" },
//                 { label: "Allow Download", key: "allowDownload", desc: "Allow learners to download materials" },
//                 { label: "Course Expiry", key: "courseExpiry", desc: "Course access will expire after due date" },
//               ].map((item) => (
//                 <div key={item.key} className="flex items-center justify-between p-4 bg-gray-50 rounded-xl border border-gray-100">
//                   <div>
//                     <p className="text-sm font-bold">{item.label}</p>
//                     <p className="text-[11px] text-gray-500">{item.desc}</p>
//                   </div>
//                   <label className="relative inline-flex items-center cursor-pointer">
//                     <input type="checkbox" name={item.key} checked={formData[item.key]} onChange={handleInputChange} className="sr-only peer" />
//                     <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-red-600"></div>
//                   </label>
//                 </div>
//               ))}
//             </div>
//           </section>
//         </div>

//         {/* Right Column: Content & Options */}
//         <div className="lg:col-span-4 space-y-6">
//           <section className="bg-white p-6 rounded-xl border shadow-sm">
//             <h2 className="text-sm font-bold text-gray-900 mb-4">Content Source</h2>
//             <div className="grid grid-cols-2 gap-3 mb-6">
//               <button 
//                 onClick={() => setContentType("upload")}
//                 className={`flex flex-col items-center justify-center p-4 border-2 rounded-xl transition ${contentType === "upload" ? "border-red-600 bg-red-50 text-red-600" : "border-gray-100 hover:border-gray-200"}`}
//               >
//                 <Upload size={24} className="mb-2" />
//                 <span className="text-xs font-bold text-center">Upload Content</span>
//               </button>
//               <button 
//                 onClick={() => setContentType("link")}
//                 className={`flex flex-col items-center justify-center p-4 border-2 rounded-xl transition ${contentType === "link" ? "border-red-600 bg-red-50 text-red-600" : "border-gray-100 hover:border-gray-200"}`}
//               >
//                 <Link size={24} className="mb-2" />
//                 <span className="text-xs font-bold text-center">Paste Link</span>
//               </button>
//             </div>
            
//             {contentType === "link" ? (
//               <div className="space-y-3">
//                 <div className="relative">
//                   <input 
//                     type="text" 
//                     placeholder="https://youtube.com/..." 
//                     className="w-full px-4 py-2.5 border rounded-lg text-sm pr-10 focus:ring-2 focus:ring-red-500 outline-none"
//                     value={linkInput}
//                     onChange={(e) => setLinkInput(e.target.value)}
//                   />
//                   {linkInput && <X size={16} className="absolute right-3 top-3 text-gray-400 cursor-pointer" onClick={() => setLinkInput("")}/>}
//                 </div>
//                 <button className="w-full bg-gray-900 text-white py-2.5 rounded-lg text-sm font-bold hover:bg-gray-800 transition">Validate Link</button>
//               </div>
//             ) : (
//               <div className="border-2 border-dashed rounded-xl p-6 text-center relative hover:bg-gray-50 cursor-pointer">
//                  <input type="file" multiple onChange={(e) => handleFileChange(e, "contents")} className="absolute inset-0 opacity-0 cursor-pointer" />
//                  <Plus size={24} className="mx-auto mb-1 text-red-600" />
//                  <span className="text-xs font-bold text-gray-700">Add Content Files</span>
//               </div>
//             )}
//           </section>

//           <section className="bg-white p-6 rounded-xl border shadow-sm">
//              <div className="flex items-center justify-between mb-4">
//                 <h2 className="text-sm font-bold flex items-center gap-1.5">Course Tags <Info size={14} className="text-gray-400"/></h2>
//                 <span className="text-[10px] text-gray-400">{formData.courseTags.length}/10</span>
//              </div>
//              <div className="flex flex-wrap gap-2 mb-4">
//                {formData.courseTags.map((tag, i) => (
//                  <span key={i} className="px-2 py-1 bg-red-50 text-red-600 text-[10px] font-bold rounded-lg flex items-center gap-1">
//                    {tag} <X size={12} className="cursor-pointer" onClick={() => setFormData({...formData, courseTags: formData.courseTags.filter((_, idx) => idx !== i)})}/>
//                  </span>
//                ))}
//              </div>
//              <div className="flex gap-2">
//                 <input 
//                   className="flex-1 border-b text-sm focus:border-red-600 outline-none pb-1" 
//                   placeholder="Type and enter..." 
//                   onKeyDown={(e) => {
//                     if (e.key === 'Enter' && e.target.value) {
//                       setFormData({...formData, courseTags: [...formData.courseTags, e.target.value]});
//                       e.target.value = "";
//                     }
//                   }}
//                 />
//              </div>
//           </section>

//           {/* Tips Section */}
//           <div className="bg-red-50 p-4 rounded-xl border border-red-100 flex gap-3">
//              <Info className="text-red-600 shrink-0" size={20} />
//              <div>
//                 <p className="text-xs font-bold text-red-900 mb-1">Tip</p>
//                 <p className="text-[11px] text-red-700 leading-relaxed">You can save this course as a draft and continue later. Changes are saved automatically when clicking Publish.</p>
//              </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LMSCourseForm;


// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { ChevronLeft, Upload, Link, X, Plus, Info, Check, FileText, Trash2 } from "lucide-react";
// import { toast } from "react-toastify";
// import api from "../../../common/apiClient";
// import SummaryApi from "../../../common/SummaryApi";
// import SelectDropdown from "../../../customStyles/SelectDropdown"; // Adjust path accordingly

// const LMSCourseForm = ({mode="create"}) => {
//   const { id, portalName } = useParams();
//   const navigate = useNavigate();
//   const isEditMode = Boolean(id);

//   const [loading, setLoading] = useState(false);
//   const [contentType, setContentType] = useState("upload");
//   const [linkInput, setLinkInput] = useState("");

//   const [formData, setFormData] = useState({
//     courseTitle: "",
//     category: "",
//     subCategory: "",
//     level: "",
//     duration: "",
//     description: "",
//     courseTags: [],
//     enableDiscussion: false,
//     requireAssessment: false,
//     allowDownload: false,
//     courseExpiry: false,
//     validityAfterCompletion: "",
//     renewalFrequency: "Never",
//     minimumPassingScore: 70,
//     maxAttempts: 3,
//     status: "Draft",
//     uploadContent: [] 
//   });

//   const [files, setFiles] = useState({
//     thumbnail: null,
//     banner: null,
//     contents: [] 
//   });

//   const [previews, setPreviews] = useState({
//     thumbnail: null,
//     banner: null
//   });

//   // Dropdown Options
//   const categories = [
//     { label: "Safety", value: "Safety" },
//     { label: "Compliance", value: "Compliance" },
//     { label: "Management", value: "Management" },
//     { label: "Soft Skills", value: "Soft Skills" },
//     { label: "Coaching", value: "Coaching" }
//   ];

//   const levels = [
//     { label: "Beginner", value: "Beginner" },
//     { label: "Intermediate", value: "Intermediate" },
//     { label: "Advanced", value: "Advanced" }
//   ];

//   const languages = [
//     { label: "English", value: "English" },
//     { label: "Tamil", value: "Tamil" },
//     { label: "Hindi", value: "Hindi" }
//   ];

//   const renewalOptions = [
//     { label: "Never", value: "Never" },
//     { label: "Monthly", value: "Monthly" },
//     { label: "Quarterly", value: "Quarterly" },
//     { label: "Half Yearly", value: "Half Yearly" },
//     { label: "Yearly", value: "Yearly" }
//   ];

//   console.log(id)

//   useEffect(() => {
//     if (isEditMode) {
//       const fetchCourse = async () => {
//         try {
//           const response = await api({ ...SummaryApi.getLmsCourseById(id) });
//           if (response.data.success) {
//             const data = response.data.data;
//             setFormData(data);
//             if (data.thumbnail?.url) setPreviews(p => ({ ...p, thumbnail: data.thumbnail.url }));
//             if (data.banner?.url) setPreviews(p => ({ ...p, banner: data.banner.url }));
//           }
//         } catch (error) {
//           toast.error("Failed to load course");
//         }
//       };
//       fetchCourse();
//     }
//   }, [id, isEditMode]);

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value
//     }));
//   };

//   const handleFileChange = (e, field) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     if (field === "contents") {
//       const newFiles = Array.from(e.target.files);
//       setFiles(prev => ({ ...prev, contents: [...prev.contents, ...newFiles] }));
      
//       // Add placeholders to uploadContent for tracking type/title in schema
//       const newContentEntries = newFiles.map(f => ({
//         title: f.name,
//         type: f.type.includes("pdf") ? "pdf" : f.type.includes("video") ? "video" : "document",
//         fileName: f.name
//       }));
//       setFormData(prev => ({ ...prev, uploadContent: [...prev.uploadContent, ...newContentEntries] }));
//     } else {
//       setFiles(prev => ({ ...prev, [field]: file }));
//       setPreviews(prev => ({ ...prev, [field]: URL.createObjectURL(file) }));
//     }
//   };

//   const addLinkContent = () => {
//     if (!linkInput) return toast.error("Please enter a URL");
//     const newLink = {
//       title: "External Link",
//       type: "link",
//       linkUrl: linkInput
//     };
//     setFormData(prev => ({ ...prev, uploadContent: [...prev.uploadContent, newLink] }));
//     setLinkInput("");
//     toast.success("Link added to content list");
//   };

//   const removeContent = (index) => {
//     setFormData(prev => ({
//       ...prev,
//       uploadContent: prev.uploadContent.filter((_, i) => i !== index)
//     }));
//     // Note: If it's a file, you might need complex logic to sync 'files.contents' array
//   };

//   const handleSubmit = async (statusOverride) => {
//     if (!formData.courseTitle || !formData.category) {
//       return toast.error("Please fill required fields (*)");
//     }

//     try {
//       setLoading(true);
//       const data = new FormData();
      
//       const payload = { ...formData, status: statusOverride || formData.status };

//       // Append standard fields
//       Object.keys(payload).forEach(key => {
//         if (["courseTags", "uploadContent", "additional"].includes(key)) {
//           data.append(key, JSON.stringify(payload[key]));
//         } else {
//           data.append(key, payload[key]);
//         }
//       });

//       // Append Files matching Controller/Route names
//       if (files.thumbnail) data.append("thumbnail", files.thumbnail);
//       if (files.banner) data.append("banner", files.banner);
//       files.contents.forEach(file => data.append("contents", file));

//       const apiConfig = isEditMode 
//         ? SummaryApi.updateLmsCourse(id) 
//         : SummaryApi.createLmsCourse;

//       const response = await api({
//         ...apiConfig,
//         data: data,
//         headers: { "Content-Type": "multipart/form-data" }
//       });

//       if (response.data.success) {
//         toast.success(`Course ${isEditMode ? "Updated" : "Created"} successfully`);
//         navigate(`/${portalName}/hr/lms-management/courses`);
//       }
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Operation failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="bg-gray-50 min-h-screen pb-20">
//       <div className="bg-white border-b sticky top-0 z-20 px-6 py-4 flex items-center justify-between shadow-sm">
//         <div className="flex items-center gap-4">
//           <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-full transition text-gray-600">
//             <ChevronLeft size={20} />
//           </button>
//           <div>
//             <h1 className="text-xl font-bold text-gray-900">{isEditMode ? "Edit Course" : "Create New Course"}</h1>
//             <p className="text-[11px] text-gray-500">Learning Management System / {isEditMode ? "Edit" : "New"}</p>
//           </div>
//         </div>
//         <div className="flex items-center gap-3">
//           <button disabled={loading} onClick={() => handleSubmit("Draft")} className="px-4 py-2 text-sm font-semibold border border-gray-300 rounded-lg hover:bg-gray-50 transition">Save as Draft</button>
//           <button disabled={loading} onClick={() => handleSubmit("Published")} className="px-4 py-2 text-sm font-semibold bg-red-600 text-white rounded-lg hover:bg-red-700 flex items-center gap-2 shadow-md transition">
//             {loading ? "Processing..." : isEditMode ? "Update Course" : "Publish Course"} <Check size={16} />
//           </button>
//         </div>
//       </div>

//       <div className="mx-auto p-4 md:p-6 grid grid-cols-1 lg:grid-cols-12 gap-6 max-w-[1600px]">
//         {/* LEFT COLUMN */}
//         <div className="lg:col-span-8 space-y-6">
//           <section className="bg-white p-6 rounded-2xl border shadow-sm">
//             <h2 className="text-md font-bold mb-6 text-gray-800 border-l-4 border-red-600 pl-3">Basic Information</h2>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//               <div className="md:col-span-1">
//                 <label className="block text-xs font-bold text-gray-500 uppercase mb-2">Course Title *</label>
//                 <input name="courseTitle" value={formData.courseTitle} onChange={handleInputChange} placeholder="Enter course title" className="w-full px-4 py-2.5 border border-gray-200 rounded-xl focus:ring-2 focus:ring-red-500 outline-none transition text-sm" />
//               </div>
//               <div>
//                 <label className="block text-xs font-bold text-gray-500 uppercase mb-2">Course Code (Auto)</label>
//                 <input disabled value={formData.courseCode || "LMS-XXXX"} className="w-full px-4 py-2.5 border border-gray-200 rounded-xl bg-gray-50 text-gray-400 text-sm" />
//               </div>
//               <div>
//                 <label className="block text-xs font-bold text-gray-500 uppercase mb-2">Category *</label>
//                 <SelectDropdown options={categories} value={formData.category} onChange={(val) => setFormData(p => ({ ...p, category: val }))} placeholder="Select Category" ChildClassName="rounded-xl border-gray-200 py-2.5" labelKey="label" valueKey="value" />
//               </div>
//               <div>
//                 <label className="block text-xs font-bold text-gray-500 uppercase mb-2">Level *</label>
//                 <SelectDropdown options={levels} value={formData.level} onChange={(val) => setFormData(p => ({ ...p, level: val }))} placeholder="Select Level" ChildClassName="rounded-xl border-gray-200 py-2.5" labelKey="label" valueKey="value" />
//               </div>
//               <div>
//                 <label className="block text-xs font-bold text-gray-500 uppercase mb-2">Language</label>
//                 <SelectDropdown options={languages} value={formData.language} onChange={(val) => setFormData(p => ({ ...p, language: val }))} placeholder="Select Language" ChildClassName="rounded-xl border-gray-200 py-2.5" labelKey="label" valueKey="value" />
//               </div>
//               <div>
//                 <label className="block text-xs font-bold text-gray-500 uppercase mb-2">Duration (Approx) *</label>
//                 <input name="duration" value={formData.duration} onChange={handleInputChange} placeholder="e.g. 2h 30m" className="w-full px-4 py-2.5 border border-gray-200 rounded-xl outline-none focus:ring-2 focus:ring-red-500 text-sm" />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-xs font-bold text-gray-500 uppercase mb-2">Description</label>
//                 <textarea name="description" value={formData.description} onChange={handleInputChange} rows={3} maxLength={500} className="w-full px-4 py-2.5 border border-gray-200 rounded-xl outline-none focus:ring-2 focus:ring-red-500 resize-none text-sm" placeholder="Brief overview of the course content..." />
//               </div>
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
//                <div className="group border-2 border-dashed border-gray-200 rounded-2xl p-4 text-center hover:border-red-500 transition-all relative min-h-[160px] flex flex-col justify-center items-center bg-gray-50/30">
//                   {previews.thumbnail ? (
//                     <img src={previews.thumbnail} className="absolute inset-0 w-full h-full object-cover rounded-2xl" alt="preview" />
//                   ) : (
//                     <>
//                       <div className="p-3 bg-red-50 rounded-full mb-2"><Upload className="text-red-600" size={24} /></div>
//                       <p className="text-xs font-bold text-gray-700">Course Thumbnail</p>
//                       <p className="text-[10px] text-gray-400 mt-1">Recommended: 1280x720 (Max 2MB)</p>
//                     </>
//                   )}
//                   <input type="file" onChange={(e) => handleFileChange(e, "thumbnail")} className="absolute inset-0 opacity-0 cursor-pointer" />
//                </div>
//                <div className="group border-2 border-dashed border-gray-200 rounded-2xl p-4 text-center hover:border-red-500 transition-all relative min-h-[160px] flex flex-col justify-center items-center bg-gray-50/30">
//                   {previews.banner ? (
//                     <img src={previews.banner} className="absolute inset-0 w-full h-full object-cover rounded-2xl" alt="preview" />
//                   ) : (
//                     <>
//                       <div className="p-3 bg-red-50 rounded-full mb-2"><Upload className="text-red-600" size={24} /></div>
//                       <p className="text-xs font-bold text-gray-700">Course Banner</p>
//                       <p className="text-[10px] text-gray-400 mt-1">Recommended: 1920x600 (Max 5MB)</p>
//                     </>
//                   )}
//                   <input type="file" onChange={(e) => handleFileChange(e, "banner")} className="absolute inset-0 opacity-0 cursor-pointer" />
//                </div>
//             </div>
//           </section>

//           <section className="bg-white p-6 rounded-2xl border shadow-sm">
//             <h2 className="text-md font-bold mb-6 text-gray-800 border-l-4 border-red-600 pl-3">Settings</h2>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               {[
//                 { label: "Enable Discussion", key: "enableDiscussion", desc: "Allow learners to interact" },
//                 { label: "Require Assessment", key: "requireAssessment", desc: "Mandatory test to pass" },
//                 { label: "Allow Download", key: "allowDownload", desc: "Enable offline materials" },
//                 { label: "Course Expiry", key: "courseExpiry", desc: "Set access time limit" },
//               ].map((item) => (
//                 <div key={item.key} className="flex items-center justify-between p-4 bg-gray-50/50 rounded-2xl border border-gray-100">
//                   <div>
//                     <p className="text-xs font-bold text-gray-800">{item.label}</p>
//                     <p className="text-[10px] text-gray-500">{item.desc}</p>
//                   </div>
//                   <label className="relative inline-flex items-center cursor-pointer">
//                     <input type="checkbox" name={item.key} checked={formData[item.key]} onChange={handleInputChange} className="sr-only peer" />
//                     <div className="w-10 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-red-600"></div>
//                   </label>
//                 </div>
//               ))}
//             </div>
//           </section>
//         </div>

//         {/* RIGHT COLUMN */}
//         <div className="lg:col-span-4 space-y-6">
//           <section className="bg-white p-5 rounded-2xl border shadow-sm">
//             <h2 className="text-sm font-bold text-gray-900 mb-4">Content Source</h2>
//             <div className="grid grid-cols-2 gap-3 mb-6">
//               <button onClick={() => setContentType("upload")} className={`flex flex-col items-center justify-center py-4 border-2 rounded-2xl transition ${contentType === "upload" ? "border-red-600 bg-red-50 text-red-600" : "border-gray-50 bg-gray-50 text-gray-400"}`}>
//                 <Upload size={20} className="mb-1" />
//                 <span className="text-[10px] font-bold">Upload Files</span>
//               </button>
//               <button onClick={() => setContentType("link")} className={`flex flex-col items-center justify-center py-4 border-2 rounded-2xl transition ${contentType === "link" ? "border-red-600 bg-red-50 text-red-600" : "border-gray-50 bg-gray-50 text-gray-400"}`}>
//                 <Link size={20} className="mb-1" />
//                 <span className="text-[10px] font-bold">External Link</span>
//               </button>
//             </div>
            
//             {contentType === "link" ? (
//               <div className="space-y-3">
//                 <input type="text" placeholder="https://youtube.com/..." className="w-full px-4 py-2 border border-gray-200 rounded-xl text-xs focus:ring-2 focus:ring-red-500 outline-none" value={linkInput} onChange={(e) => setLinkInput(e.target.value)} />
//                 <button onClick={addLinkContent} className="w-full bg-red-600 text-white py-2 rounded-xl text-xs font-bold hover:bg-red-700 transition">Add Link</button>
//               </div>
//             ) : (
//               <div className="border-2 border-dashed border-gray-200 rounded-2xl p-6 text-center relative hover:bg-red-50/30 cursor-pointer">
//                  <input type="file" multiple onChange={(e) => handleFileChange(e, "contents")} className="absolute inset-0 opacity-0 cursor-pointer" />
//                  <Plus size={20} className="mx-auto mb-1 text-red-600" />
//                  <span className="text-[10px] font-bold text-gray-500">Upload PDF, Video or MP4</span>
//               </div>
//             )}

//             {/* List of content already added */}
//             <div className="mt-4 space-y-2">
//               {formData.uploadContent.map((item, idx) => (
//                 <div key={idx} className="flex items-center justify-between p-2 bg-gray-50 rounded-lg border border-gray-100 text-[11px]">
//                   <div className="flex items-center gap-2 overflow-hidden">
//                     {item.type === "link" ? <Link size={14} className="text-blue-500"/> : <FileText size={14} className="text-red-500"/>}
//                     <span className="truncate max-w-[150px]">{item.title || item.linkUrl}</span>
//                   </div>
//                   <button onClick={() => removeContent(idx)} className="text-red-400 hover:text-red-600"><Trash2 size={14}/></button>
//                 </div>
//               ))}
//             </div>
//           </section>

//           <section className="bg-white p-5 rounded-2xl border shadow-sm">
//              <div className="flex items-center justify-between mb-4">
//                 <h2 className="text-sm font-bold flex items-center gap-1.5 text-gray-800">Course Tags <Info size={14} className="text-gray-300"/></h2>
//                 <span className="text-[10px] text-gray-400">{formData.courseTags.length}/10</span>
//              </div>
//              <div className="flex flex-wrap gap-2 mb-4">
//                {formData.courseTags.map((tag, i) => (
//                  <span key={i} className="px-2 py-1 bg-red-50 text-red-600 text-[10px] font-bold rounded-lg flex items-center gap-1 border border-red-100">
//                    {tag} <X size={12} className="cursor-pointer" onClick={() => setFormData({...formData, courseTags: formData.courseTags.filter((_, idx) => idx !== i)})}/>
//                  </span>
//                ))}
//              </div>
//              <input className="w-full border-b border-gray-200 text-xs focus:border-red-600 outline-none pb-2" placeholder="Press Enter to add tag..." onKeyDown={(e) => {
//                 if (e.key === 'Enter' && e.target.value) {
//                   setFormData({...formData, courseTags: [...formData.courseTags, e.target.value]});
//                   e.target.value = "";
//                 }
//              }}/>
//           </section>

//           <section className="bg-white p-5 rounded-2xl border shadow-sm">
//              <h2 className="text-sm font-bold text-gray-800 mb-4">Additional Options</h2>
//              <div className="space-y-4">
//                <div>
//                   <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Renewal Frequency</label>
//                   <SelectDropdown options={renewalOptions} value={formData.renewalFrequency} onChange={(val) => setFormData(p => ({ ...p, renewalFrequency: val }))} placeholder="Select Frequency" ChildClassName="rounded-xl border-gray-100 text-xs" labelKey="label" valueKey="value" />
//                </div>
//                <div className="grid grid-cols-2 gap-3">
//                   <div>
//                     <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Passing Score (%)</label>
//                     <input name="minimumPassingScore" type="number" value={formData.minimumPassingScore} onChange={handleInputChange} className="w-full px-3 py-2 border border-gray-100 rounded-xl text-xs outline-none focus:ring-1 focus:ring-red-500" />
//                   </div>
//                   <div>
//                     <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Max Attempts</label>
//                     <input name="maxAttempts" type="number" value={formData.maxAttempts} onChange={handleInputChange} className="w-full px-3 py-2 border border-gray-100 rounded-xl text-xs outline-none focus:ring-1 focus:ring-red-500" />
//                   </div>
//                </div>
//              </div>
//           </section>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LMSCourseForm;

import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ChevronLeft, Upload, Link, X, Plus, Check, FileText, Trash2, Edit2, ExternalLink } from "lucide-react";
import { toast } from "react-toastify";
import api from "../../../common/apiClient";
import SummaryApi from "../../../common/SummaryApi";
import SelectDropdown from "../../../customStyles/SelectDropdown";

const LMSCourseForm = ({ mode = "create" }) => {
  const { id, portalName } = useParams();
  const navigate = useNavigate();

  // Mode helpers
  const isViewMode = mode === "view";
  const isEditMode = mode === "edit";

  const [loading, setLoading] = useState(false);
  const [contentType, setContentType] = useState("upload");
  const [linkInput, setLinkInput] = useState("");
  const [editingLinkIndex, setEditingLinkIndex] = useState(null);

  const [formData, setFormData] = useState({
    courseTitle: "",
    category: "",
    subCategory: "",
    level: "",
    duration: "",
    description: "",
    courseTags: [],
    enableDiscussion: false,
    requireAssessment: false,
    allowDownload: false,
    courseExpiry: false,
    validityAfterCompletion: 0,
    renewalFrequency: "Never",
    minimumPassingScore: 70,
    maxAttempts: 3,
    status: "Draft",
    uploadContent: []
  });

  const [files, setFiles] = useState({
    thumbnail: null,
    banner: null,
    contents: []
  });

  const [previews, setPreviews] = useState({
    thumbnail: null,
    banner: null
  });

  // Options for Dropdowns
  const categories = [
    { id: "Safety", label: "Safety" },
    { id: "Compliance", label: "Compliance" },
    { id: "Management", label: "Management" },
    { id: "Soft Skills", label: "Soft Skills" },
    { id: "Coaching", label: "Coaching" }
  ];

  const levels = [
    { id: "Beginner", label: "Beginner" },
    { id: "Intermediate", label: "Intermediate" },
    { id: "Advanced", label: "Advanced" }
  ];

  const renewalOptions = [
    { id: "Never", label: "Never" },
    { id: "Monthly", label: "Monthly" },
    { id: "Quarterly", label: "Quarterly" },
    { id: "Half Yearly", label: "Half Yearly" },
    { id: "Yearly", label: "Yearly" }
  ];

  const statusOptions = [
    { id: "Draft", label: "Draft" },
    { id: "Published", label: "Published" }
  ];

  // Load Data for Edit or View Mode
  useEffect(() => {
    if (id) {
      const fetchCourse = async () => {
        try {
          setLoading(true);
          const response = await api({
            url: SummaryApi.getLmsCourseById.url(id),
            method: SummaryApi.getLmsCourseById.method,
          });
          if (response.data.success) {
            const data = response.data.data;
            
            // STICT EXTRACTION: Only pick fields used in the form
            setFormData({
              courseTitle: data.courseTitle || "",
              category: data.category || "",
              subCategory: data.subCategory || "",
              level: data.level || "",
              duration: data.duration || "",
              description: data.description || "",
              courseTags: data.courseTags || [],
              enableDiscussion: data.enableDiscussion || false,
              requireAssessment: data.requireAssessment || false,
              allowDownload: data.allowDownload || false,
              courseExpiry: data.courseExpiry || false,
              validityAfterCompletion: data.validityAfterCompletion || 0,
              renewalFrequency: data.renewalFrequency || "Never",
              minimumPassingScore: data.minimumPassingScore || 0,
              maxAttempts: data.maxAttempts || 1,
              status: data.status || "Draft",
              // Extract content but strip internal sub-document IDs to prevent update errors
              uploadContent: (data.uploadContent || []).map(item => ({
                title: item.title,
                type: item.type,
                fileName: item.fileName,
                fileUrl: item.fileUrl,
                linkUrl: item.linkUrl,
                duration: item.duration,
                order: item.order
              }))
            });

            if (data.thumbnail?.url) setPreviews(p => ({ ...p, thumbnail: data.thumbnail.url }));
            if (data.banner?.url) setPreviews(p => ({ ...p, banner: data.banner.url }));
          }
        } catch (error) {
          toast.error("Error fetching course data");
          console.error(error);
        } finally {
          setLoading(false);
        }
      };
      fetchCourse();
    }
  }, [id]);

  const handleInputChange = (e) => {
    if (isViewMode) return;
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleFileChange = (e, field) => {
    if (isViewMode) return;
    const file = e.target.files[0];
    if (!file) return;

    if (field === "contents") {
      const newFiles = Array.from(e.target.files);
      setFiles(prev => ({ ...prev, contents: [...prev.contents, ...newFiles] }));
      
      const newContentEntries = newFiles.map(f => ({
        title: f.name,
        type: f.type.includes("pdf") ? "pdf" : f.type.includes("video") ? "video" : "document",
        fileName: f.name,
        order: formData.uploadContent.length + 1
      }));
      setFormData(prev => ({ ...prev, uploadContent: [...prev.uploadContent, ...newContentEntries] }));
    } else {
      setFiles(prev => ({ ...prev, [field]: file }));
      setPreviews(prev => ({ ...prev, [field]: URL.createObjectURL(file) }));
    }
  };

  const handleRemoveImage = (field) => {
    if (isViewMode) return;
    setFiles(prev => ({ ...prev, [field]: null }));
    setPreviews(prev => ({ ...prev, [field]: null }));
  };

  const addLinkContent = () => {
    if (isViewMode) return;
    if (!linkInput) return toast.error("Please enter a valid URL");
    
    if (editingLinkIndex !== null) {
      const updatedContent = [...formData.uploadContent];
      updatedContent[editingLinkIndex] = {
        ...updatedContent[editingLinkIndex],
        linkUrl: linkInput,
        title: "External Link"
      };
      setFormData(prev => ({ ...prev, uploadContent: updatedContent }));
      setEditingLinkIndex(null);
      toast.success("Link updated");
    } else {
      const newLink = {
        title: "External Link",
        type: "link",
        linkUrl: linkInput,
        order: formData.uploadContent.length + 1
      };
      setFormData(prev => ({ ...prev, uploadContent: [...prev.uploadContent, newLink] }));
      toast.success("Link added");
    }
    setLinkInput("");
  };

  const handleEditLink = (index) => {
    if (isViewMode) return;
    const item = formData.uploadContent[index];
    setContentType("link");
    setLinkInput(item.linkUrl);
    setEditingLinkIndex(index);
  };

  const removeContent = (index) => {
    if (isViewMode) return;
    setFormData(prev => ({
      ...prev,
      uploadContent: prev.uploadContent.filter((_, i) => i !== index)
    }));
    if (editingLinkIndex === index) {
        setEditingLinkIndex(null);
        setLinkInput("");
    }
  };

  const handleSubmit = async (statusOverride) => {
    if (isViewMode) return;
    if (!formData.courseTitle || !formData.category) {
      return toast.error("Required fields marked with * are missing");
    }

    try {
      setLoading(true);
      const data = new FormData();
      
      //  STICK PAYLOAD: Explicitly define allowed keys to send to backend
      const keysToSubmit = [
        "courseTitle", "category", "subCategory", "level", "duration", 
        "description", "courseTags", "enableDiscussion", "requireAssessment", 
        "allowDownload", "courseExpiry", "validityAfterCompletion", 
        "renewalFrequency", "minimumPassingScore", "maxAttempts", "status", 
        "uploadContent"
      ];

      keysToSubmit.forEach(key => {
        let value = formData[key];

        // Ensure proper types for numeric fields to avoid cast errors
        if (["validityAfterCompletion", "minimumPassingScore", "maxAttempts"].includes(key)) {
          value = Number(value) || 0;
        }

        if (["courseTags", "uploadContent"].includes(key)) {
          data.append(key, JSON.stringify(value));
        } else {
          data.append(key, key === "status" && statusOverride ? statusOverride : value);
        }
      });

      if (files.thumbnail) data.append("thumbnail", files.thumbnail);
      if (files.banner) data.append("banner", files.banner);
      files.contents.forEach(file => data.append("contents", file));

      const apiConfig = isEditMode 
        ? { url: SummaryApi.updateLmsCourse.url(id), method: SummaryApi.updateLmsCourse.method } 
        : SummaryApi.createLmsCourse;

      const response = await api({
        ...apiConfig,
        data: data,
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (response.data.success) {
        toast.success(`Course ${isEditMode ? "updated" : "created"} successfully`);
        navigate(`/${portalName}/hr/lms-management/courses`);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Operation failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-50 min-h-screen pb-20">
      <div className="bg-white border-b sticky top-0 z-20 px-6 py-4 flex items-center justify-between shadow-sm">
        <div className="flex items-center gap-4">
          <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-full transition text-gray-600"><ChevronLeft size={20} /></button>
          <div>
            <h1 className="text-xl font-bold text-gray-900">{isViewMode ? "Course Details" : isEditMode ? "Edit Course" : "Create New Course"}</h1>
            <p className="text-[11px] text-gray-500 uppercase tracking-widest font-bold">LMS / {mode}</p>
          </div>
        </div>
        
        {!isViewMode && (
          <div className="flex items-center gap-3">
            <button disabled={loading} onClick={() => handleSubmit("Draft")} className="px-4 py-2 text-sm font-semibold border border-gray-300 rounded-lg hover:bg-gray-50 transition">Save as Draft</button>
            <button disabled={loading} onClick={() => handleSubmit("Published")} className="px-4 py-2 text-sm font-semibold bg-red-600 text-white rounded-lg hover:bg-red-700 flex items-center gap-2 shadow-md transition-all">{loading ? "Processing..." : isEditMode ? "Update" : "Publish"} <Check size={16} /></button>
          </div>
        )}
      </div>

      <div className="mx-auto p-4 md:p-6 grid grid-cols-1 lg:grid-cols-12 gap-6 max-w-[1600px]">
        <div className="lg:col-span-8 space-y-6">
          <section className="bg-white p-6 rounded-2xl border shadow-sm">
            <h2 className="text-md font-bold mb-6 text-gray-800 border-l-4 border-red-600 pl-3">Basic Information</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div className="md:col-span-1"><label className="block text-xs font-bold text-gray-500 uppercase mb-2">Course Title *</label><input disabled={isViewMode} name="courseTitle" value={formData.courseTitle} onChange={handleInputChange} placeholder="Enter title" className="w-full px-4 py-2.5 border border-gray-200 rounded-xl outline-none focus:ring-2 focus:ring-red-500 text-sm disabled:bg-gray-50" /></div>
              <div><label className="block text-xs font-bold text-gray-500 uppercase mb-2">Course Code</label><input disabled value={formData.courseCode || "LMS-XXXX"} className="w-full px-4 py-2.5 border border-gray-200 rounded-xl bg-gray-50 text-gray-400 text-sm" /></div>
              <div><label className="block text-xs font-bold text-gray-500 uppercase mb-2">Category *</label><SelectDropdown disabled={isViewMode} options={categories} value={formData.category} onChange={(val) => setFormData(p => ({ ...p, category: val }))} placeholder="Select Category" ChildClassName="rounded-xl" /></div>
              <div><label className="block text-xs font-bold text-gray-500 uppercase mb-2">Level</label><SelectDropdown disabled={isViewMode} options={levels} value={formData.level} onChange={(val) => setFormData(p => ({ ...p, level: val }))} placeholder="Select Level" ChildClassName="rounded-xl" /></div>
              <div><label className="block text-xs font-bold text-gray-500 uppercase mb-2">Duration *</label><input disabled={isViewMode} name="duration" value={formData.duration} onChange={handleInputChange} placeholder="e.g. 2h 30m" className="w-full px-4 py-2.5 border border-gray-200 rounded-xl outline-none focus:ring-2 focus:ring-red-500 text-sm" /></div>
              <div className="md:col-span-2"><label className="block text-xs font-bold text-gray-500 uppercase mb-2">Description</label><textarea disabled={isViewMode} name="description" value={formData.description} onChange={handleInputChange} rows={3} className="w-full px-4 py-2.5 border border-gray-200 rounded-xl outline-none text-sm resize-none disabled:bg-gray-50" /></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
               <div className="space-y-2"><label className="block text-xs font-bold text-gray-500 uppercase">Course Thumbnail</label>
                  <div className={`group relative border-2 border-dashed rounded-2xl p-4 text-center min-h-[180px] flex flex-col justify-center items-center bg-gray-50/30 transition-all ${!isViewMode && "hover:border-red-500 cursor-pointer"}`}>
                      {previews.thumbnail ? (<><img src={previews.thumbnail} className="absolute inset-0 w-full h-full object-cover rounded-2xl" alt="thumb" />{!isViewMode && (<div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center rounded-2xl gap-2"><button type="button" onClick={() => handleRemoveImage('thumbnail')} className="p-2 bg-red-600 text-white rounded-full hover:bg-red-700 shadow-lg"><Trash2 size={18} /></button><label className="p-2 bg-white text-gray-900 rounded-full hover:bg-gray-100 shadow-lg cursor-pointer"><Upload size={18} /><input type="file" onChange={(e) => handleFileChange(e, "thumbnail")} className="hidden" /></label></div>)}</>) : (<><Upload className="text-red-600 mb-2" size={24} /><p className="text-xs font-bold text-gray-700">Upload Thumbnail</p><input type="file" onChange={(e) => handleFileChange(e, "thumbnail")} className="absolute inset-0 opacity-0 cursor-pointer" disabled={isViewMode} /></>)}
                  </div>
               </div>
               <div className="space-y-2"><label className="block text-xs font-bold text-gray-500 uppercase">Course Banner</label>
                  <div className={`group relative border-2 border-dashed rounded-2xl p-4 text-center min-h-[180px] flex flex-col justify-center items-center bg-gray-50/30 transition-all ${!isViewMode && "hover:border-red-500 cursor-pointer"}`}>
                      {previews.banner ? (<><img src={previews.banner} className="absolute inset-0 w-full h-full object-cover rounded-2xl" alt="banner" />{!isViewMode && (<div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center rounded-2xl gap-2"><button type="button" onClick={() => handleRemoveImage('banner')} className="p-2 bg-red-600 text-white rounded-full hover:bg-red-700 shadow-lg"><Trash2 size={18} /></button><label className="p-2 bg-white text-gray-900 rounded-full hover:bg-gray-100 shadow-lg cursor-pointer"><Upload size={18} /><input type="file" onChange={(e) => handleFileChange(e, "banner")} className="hidden" /></label></div>)}</>) : (<><Upload className="text-red-600 mb-2" size={24} /><p className="text-xs font-bold text-gray-700">Upload Banner</p><input type="file" onChange={(e) => handleFileChange(e, "banner")} className="absolute inset-0 opacity-0 cursor-pointer" disabled={isViewMode} /></>)}
                  </div>
               </div>
            </div>
          </section>

          <section className="bg-white p-6 rounded-2xl border shadow-sm">
            <h2 className="text-md font-bold mb-6 text-gray-800 border-l-4 border-red-600 pl-3">Settings</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[{ label: "Enable Discussion", key: "enableDiscussion" }, { label: "Require Assessment", key: "requireAssessment" }, { label: "Allow Download", key: "allowDownload" }, { label: "Course Expiry", key: "courseExpiry" }].map((item) => (
                <div key={item.key} className="flex items-center justify-between p-4 bg-gray-50/50 rounded-2xl border border-gray-100">
                  <p className="text-xs font-bold text-gray-800">{item.label}</p>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input disabled={isViewMode} type="checkbox" name={item.key} checked={formData[item.key]} onChange={handleInputChange} className="sr-only peer" />
                    <div className="w-9 h-5 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-red-600"></div>
                  </label>
                </div>
              ))}
            </div>
          </section>
        </div>

        <div className="lg:col-span-4 space-y-6">
          <section className="bg-white p-5 rounded-2xl border shadow-sm">
            <h2 className="text-sm font-bold text-gray-900 mb-4">Content Source</h2>
            {!isViewMode && (
              <div className="grid grid-cols-2 gap-3 mb-6">
                <button onClick={() => { setContentType("upload"); setEditingLinkIndex(null); setLinkInput(""); }} className={`py-4 border-2 rounded-2xl flex flex-col items-center transition ${contentType === "upload" ? "border-red-600 bg-red-50 text-red-600" : "border-gray-50 bg-gray-50 text-gray-400"}`}><Upload size={20} className="mb-1" /><span className="text-[10px] font-bold">Files</span></button>
                <button onClick={() => setContentType("link")} className={`py-4 border-2 rounded-2xl flex flex-col items-center transition ${contentType === "link" ? "border-red-600 bg-red-50 text-red-600" : "border-gray-50 bg-gray-50 text-gray-400"}`}><Link size={20} className="mb-1" /><span className="text-[10px] font-bold">Link</span></button>
              </div>
            )}
            {!isViewMode && contentType === "link" ? (
              <div className="space-y-3"><input type="text" placeholder="https://..." className="w-full px-4 py-2 border border-gray-200 rounded-xl text-xs outline-none focus:ring-1 focus:ring-red-500" value={linkInput} onChange={(e) => setLinkInput(e.target.value)} /><button onClick={addLinkContent} className="w-full bg-red-600 text-white py-2 rounded-xl text-xs font-bold">{editingLinkIndex !== null ? "Update" : "Add"} Link</button></div>
            ) : !isViewMode && (<div className="border-2 border-dashed border-gray-200 rounded-2xl p-6 text-center relative hover:bg-red-50/30 cursor-pointer transition-colors"><input type="file" multiple onChange={(e) => handleFileChange(e, "contents")} className="absolute inset-0 opacity-0 cursor-pointer" /><Plus size={20} className="mx-auto mb-1 text-red-600" /><span className="text-[10px] font-bold text-gray-500">Upload Course Files</span></div>)}

            <div className="mt-4 space-y-2">
              {formData.uploadContent?.map((item, idx) => (
                <div key={idx} className="flex items-center justify-between p-2.5 bg-gray-50 rounded-xl border border-gray-100 text-[11px] group"><div className="flex items-center gap-2 truncate flex-1">{item.type === "link" ? <Link size={14} className="text-blue-500 shrink-0"/> : <FileText size={14} className="text-red-500 shrink-0"/>}<span className="truncate font-medium text-gray-700">{item.title || item.linkUrl || item.fileName}</span></div><div className="flex items-center gap-1">{item.linkUrl && (<button type="button" onClick={() => window.open(item.linkUrl, '_blank')} className="p-1.5 text-blue-600 hover:bg-blue-100 rounded-lg"><ExternalLink size={14}/></button>)}{!isViewMode && (<>{item.type === "link" && (<button type="button" onClick={() => handleEditLink(idx)} className="p-1.5 text-gray-500 hover:bg-gray-200 rounded-lg"><Edit2 size={14}/></button>)}<button type="button" onClick={() => removeContent(idx)} className="p-1.5 text-red-400 hover:bg-red-100 rounded-lg"><Trash2 size={14}/></button></>)}</div></div>
              ))}
            </div>
          </section>

          <section className="bg-white p-5 rounded-2xl border shadow-sm"><div className="flex items-center justify-between mb-4"><h2 className="text-sm font-bold text-gray-800">Course Tags</h2><span className="text-[10px] text-gray-400">{formData.courseTags.length}/10</span></div><div className="flex flex-wrap gap-2 mb-4">{formData.courseTags.map((tag, i) => (<span key={i} className="px-2 py-1 bg-red-50 text-red-600 text-[10px] font-bold rounded-lg flex items-center gap-1 border border-red-100">{tag} {!isViewMode && <X size={12} className="cursor-pointer" onClick={() => setFormData({...formData, courseTags: formData.courseTags.filter((_, idx) => idx !== i)})}/>}</span>))}</div>{!isViewMode && (<input className="w-full border-b border-gray-200 text-xs focus:border-red-600 outline-none pb-2" placeholder="Press Enter to add tag..." onKeyDown={(e) => { if (e.key === 'Enter' && e.target.value) { e.preventDefault(); if(formData.courseTags.length >= 10) return; setFormData({...formData, courseTags: [...formData.courseTags, e.target.value]}); e.target.value = ""; } }}/>)}</section>

          <section className="bg-white p-5 rounded-2xl border shadow-sm">
             <h2 className="text-sm font-bold text-gray-800 mb-4">Additional Options</h2>
             <div className="space-y-4">
                <div><label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Course Status</label><SelectDropdown disabled={isViewMode} options={statusOptions} value={formData.status} onChange={(val) => setFormData(p => ({ ...p, status: val }))} ChildClassName="rounded-xl" /></div>
                <div><label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Renewal Frequency</label><SelectDropdown disabled={isViewMode} options={renewalOptions} value={formData.renewalFrequency} onChange={(val) => setFormData(p => ({ ...p, renewalFrequency: val }))} ChildClassName="rounded-xl" /></div>
                <div><label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Validity (Days)</label><input disabled={isViewMode} name="validityAfterCompletion" type="number" value={formData.validityAfterCompletion} onChange={handleInputChange} className="w-full px-3 py-2 border border-gray-100 rounded-xl text-xs outline-none" /></div>
                <div className="grid grid-cols-2 gap-3">
                    <div><label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Pass Score (%)</label><input disabled={isViewMode} name="minimumPassingScore" type="number" value={formData.minimumPassingScore} onChange={handleInputChange} className="w-full px-3 py-2 border border-gray-100 rounded-xl text-xs outline-none" /></div>
                    <div><label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Max Attempts</label><input disabled={isViewMode} name="maxAttempts" type="number" value={formData.maxAttempts} onChange={handleInputChange} className="w-full px-3 py-2 border border-gray-100 rounded-xl text-xs outline-none" /></div>
                </div>
             </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default LMSCourseForm;